(() => {
  if (window.ApexMediaSliderVideoLazy) return;
  window.ApexMediaSliderVideoLazy = true;

  const COMPONENT_SELECTOR = 'splide-component.ms-modern-block';

  const componentObservers = new Map();

  function hydrate(container) {
    if (!container || container.dataset.hydrated === 'true') return;

    const template = container.querySelector('[data-deferred-video-template]');
    if (!template) return;

    const content = template.content.cloneNode(true);
    content.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    container.dataset.hydrated = 'true';
    container.replaceChildren(content);
  }

  function pauseInactive(component) {
    component.querySelectorAll('.splide__slide:not(.is-active) video').forEach((video) => {
      if (!video.paused) video.pause();
    });
  }

  function hydrateActive(component) {
    const active = component.querySelector('.splide__slide.is-active [data-deferred-video]');
    hydrate(active);
    pauseInactive(component);
  }

  function activate(component) {
    if (component.dataset.videoLazyActive === 'true') return;
    component.dataset.videoLazyActive = 'true';

    let queued = false;
    const refresh = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        hydrateActive(component);
      });
    };

    const mutationObserver = new MutationObserver(refresh);
    mutationObserver.observe(component, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    componentObservers.set(component, mutationObserver);

    component.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-deferred-video-trigger]');
      if (!trigger) return;
      const deferredVideo = trigger.closest('[data-deferred-video]');
      component.querySelectorAll('video').forEach((video) => video.pause());
      hydrate(deferredVideo);
    });

    refresh();
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        activate(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '400px 0px' }
  );

  function observe(root = document) {
    root.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
      if (component.dataset.videoLazyObserved === 'true') return;
      component.dataset.videoLazyObserved = 'true';
      observer.observe(component);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observe(), { once: true });
  } else {
    observe();
  }

  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(COMPONENT_SELECTOR).forEach((component) => {
      componentObservers.get(component)?.disconnect();
      componentObservers.delete(component);
      observer.unobserve(component);
    });
  });
})();
